export default "__VITE_ASSET__CXaFXp2R__"